import { ReactNode } from "react";

export enum MDSBubbleSlotName {
  Icon = "icon",
  Loader = "loader",
  Error = "error",
}

export enum MDSBubbleVariant {
  Green = "green",
  DarkGrey = "darkGrey",
  Grey = "grey",
  Image = "image",
  Transparent = "transparent",
}

export enum MDSBubbleAlignment {
  Left = "left",
  Right = "right",
}

export interface MDSBubbleProps {
  /** The main content of the bubble */
  children: ReactNode;
  /** Alignment of the bubble */
  align?: MDSBubbleAlignment;
  /** Whether this is the last bubble in a group */
  isLastInGroup?: boolean;
  /** Whether the bubble is in a loading state */
  isLoading?: boolean;
  /** Whether the bubble has errored */
  hasError?: boolean;
  /** Optional click handler for the bubble */
  onClick?: () => void;
  /** Optional class name for additional styling */
  className?: string;
  /** Style variant of the bubble */
  variant?: MDSBubbleVariant;
}

export interface MDSBubbleSlottedProps extends MDSBubbleProps {
  /** Optional slotted children for customization */
  children: ReactNode | ReactNode[];
}
